
export const GET_PAST_ORDERS_OF_VENUE= 'GET_PAST_ORDERS_OF_VENUE'
export const GET_PAST_ORDERS_OF_VENUE_SUCCESS= 'GET_PAST_ORDERS_OF_VENUE_SUCCESS'
export const GET_PAST_ORDERS_OF_VENUE_ERROR='GET_PAST_ORDERS_OF_VENUE_ERROR'


export const GetPastOrdersOfVenue= (data) => ({
    type: GET_PAST_ORDERS_OF_VENUE,
    payload: data
});
